// Resolve the API base URL. In the browser we use the SAME origin the page is
// served from, so API calls never trigger a cross-origin redirect when the site
// is reached on a non-canonical host (e.g. bare-domain <-> www). This makes the
// app robust to the edge/CDN canonicalization. Falls back to
// REACT_APP_BACKEND_URL when window is unavailable (build/SSR).
export function backendUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE = `${backendUrl()}/api`;
